import { render } from "./PopList.vue?vue&type=template&id=8fa0b46a"
import script from "./PopList.vue?vue&type=script&lang=js"
export * from "./PopList.vue?vue&type=script&lang=js"

import "./PopList.vue?vue&type=style&index=0&id=8fa0b46a&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\oltcare-front\\olt_care\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__